export class InvalidArgument extends Error {
    constructor(argument: string, expected: string, actual: string) {
        super(`Invalid value for argument '${argument}': expected: ${expected}; actual: ${actual}'`);
    }
}